import { render, staticRenderFns } from "./addCommunityWechat.vue?vue&type=template&id=712303a6"
import script from "./addCommunityWechat.vue?vue&type=script&lang=js"
export * from "./addCommunityWechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports